import React from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router';
import _ from 'lodash';
import { isEqual as sameAddress } from 'shared/models/address';
import { getCurations, getFeaturedAndCurations } from './actions';
import { track } from 'shared/models/analytic';
import HeadTags from 'components/home/head';
import AsyncLeadCaptureModal from 'components/leadCaptureModal/async';
import StorefrontOrderTracking from 'components/orderTracking/Storefront';
import Featured from './featured';
import Curated from './curated';
import MediaLogos from 'scy/MediaLogos';
import Card from 'scy/Card';
import LoadingSpinner from 'scy/LoadingSpinner';
import { ExtraWideContainer } from 'scy/layouts';
import { MutedBackground } from 'scy/Background';
import padding from 'scy/padding.mod.scss';
import margin from 'scy/margin.mod.scss';
import { relative } from 'scy/position.mod.scss';
import styles from './styles.mod.scss';

class Storefront extends React.Component {
  componentDidMount() {
    track('Storefront Viewed');
    if (!this.props.featured.carousel.length) {
      this.props.getFeaturedAndCurations();
    } else if (!this.props.curations.length) {
      this.props.getCurations();
    }
  }

  componentDidUpdate(prevProps) {
    const addressHasChanged = !sameAddress(
      prevProps.address,
      this.props.address
    );
    const prevUser = prevProps.user || {};
    const nextUser = this.props.user || {};
    const userHasChanged = prevUser.objectId !== nextUser.objectId;
    if (addressHasChanged || userHasChanged) {
      this.props.getFeaturedAndCurations();
    }
  }

  render() {
    const showLandingPage = _.isEmpty(this.props.address);
    const { featured, curationsLoading, curations } = this.props;
    const featuredLoading = !featured.carousel || !featured.carousel.length;

    if (showLandingPage) return <Redirect to="/" />;

    return (
      <ExtraWideContainer tag={MutedBackground} className={styles.container}>
        <HeadTags />
        <Content
          featured={featured}
          curations={curations}
          featuredLoading={featuredLoading}
          curationsLoading={curationsLoading}
        />
        <MediaLogos className={margin.top_md} />
        <AsyncLeadCaptureModal />
        <StorefrontOrderTracking user={this.props.user} />
      </ExtraWideContainer>
    );
  }
}

const Loading = () => (
  <Card className={relative}>
    <div className={padding.xl}>
      <LoadingSpinner black />
    </div>
  </Card>
);

function Content({ featured, curations, featuredLoading, curationsLoading }) {
  if (featuredLoading && curationsLoading) return <Loading />;
  return (
    <>
      {featuredLoading ? <Loading /> : <Featured {...featured} />}
      {curationsLoading ? <Loading /> : <Curated curations={curations} />}
    </>
  );
}

const ConnectedStorefront = connect(
  state => ({
    address: state.address,
    featured: state.storefront.featured,
    curationsLoading: state.storefront.curationsLoading,
    curations: state.storefront.curations,
    user: state.login.user
  }),
  { getCurations, getFeaturedAndCurations }
)(Storefront);

export default ConnectedStorefront;
